/* eslint react/prop-types: 0 */
import PropTypes from 'prop-types';
import React from 'react';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { ModelYear, Vehicle } from '@sm360/widget-commons-vehicle';
import { UtilsService } from '@sm360/widget-commons-general';

import { isEmpty } from 'lodash';

import URL from 'build-and-quote/constants/url.js';
import PaymentMethod from 'build-and-quote/components/ModelYears/Components/PaymentMethod.jsx';

import 'build-and-quote/components/ModelYears/modelYear.scss';

class ModelYearComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isHover: false,
        };

        this.focusInBuildButton = this.focusInBuildButton.bind(this);
        this.focusOutBuildButton = this.focusOutBuildButton.bind(this);
    }

    focusInBuildButton() {
        this.setState({
            isHover: true,
        });
    }

    focusOutBuildButton() {
        this.setState({
            isHover: false,
        });
    }

    render() {
        const {
            paymentFrequencyLabel,
            year,
            selectedModel,
            imageServer,
            onYearClick,
            noMakeListStr,
            modelListStr,
        } = this.props;
        const { purchaseMethods } = year;

        const yearImageUrl = year.exteriorColours.photo1;

        const imageServerDomain = imageServer
            ? imageServer.imageServerDomain + imageServer.imageServerRelative
            : undefined;

        const rebate = year.highRebate || purchaseMethods.cashPurchase.getTotalRebatesWithTaxes();
        const modelElectricRebate = purchaseMethods.getElectricRebate();
        const isThereRebate =
            !isEmpty(modelElectricRebate) && !!modelElectricRebate.rebate && !Number.isNaN(modelElectricRebate.rebate);
        const electricRebateAmount = isThereRebate ? Number.parseInt(modelElectricRebate.rebate, 10) : 0;

        const isFinanceAvailable = purchaseMethods.finance.hasValidTerms;
        const selectedFinanceTerm = purchaseMethods.finance.getSelectedTerm();
        const calculatedFinancePayment = purchaseMethods.finance.getCalculatedPayment();
        const financeCashDown = purchaseMethods.finance.getCashDown();

        const isLeaseAvailable = purchaseMethods.lease.hasValidTerms;
        const selectedLeaseTerm = purchaseMethods.lease.getSelectedTerm();
        const calculatedLeasePayment = purchaseMethods.lease.getCalculatedPayment();
        const leaseCashDown = purchaseMethods.lease.getCashDown();

        const { disclaimers } = purchaseMethods;
        const taxesExcludedDisclaimer =
            disclaimers && disclaimers.pricePaymentsTaxesExcluded
                ? disclaimers.pricePaymentsTaxesExcluded
                : LocaleService.t('modelYearSection.NOT_INCLUDED_IN_PRICE');

        const buildButtonClass = ['sr-button-outline-2'];
        if (this.state.isHover) {
            buildButtonClass.push('is-hover');
        }
        return (
            <div
                className="selection-year-bloc"
                role="button"
                tabIndex={0}
                onClick={onYearClick}
                onMouseOver={this.focusInBuildButton}
                onFocus={this.focusInBuildButton}
                onMouseOut={this.focusOutBuildButton}
                onBlur={this.focusOutBuildButton}
            >
                <div className="selection-year-bloc__wrapper">
                    <Vehicle.VehicleRebate rebate={rebate} electricRebate={electricRebateAmount} />
                    <div className="selection-year-bloc__photo">
                        <img
                            alt={LocaleService.t('MISSING_PHOTO.NOT_AVAILABLE')}
                            src={
                                imageServerDomain && yearImageUrl
                                    ? imageServerDomain + yearImageUrl
                                    : imageServer.imageServerDomain + URL.NO_PHOTO
                            }
                        />
                    </div>
                    {this.props.displayFactoryOrder && (
                        <div className="selection-year-bloc__label">
                            <span>{LocaleService.t('VEHICLE_STATUS.FACTORY_ORDER')}</span>
                        </div>
                    )}
                    <div className="selection-year-bloc__model sr-text is-bold">
                        {UtilsService.getNewModelName({
                            model: selectedModel.model || '',
                            make: selectedModel.make || '',
                            noMakeListStr,
                            modelListStr,
                        })}
                    </div>
                    <div className="selection-year-bloc__year sr-title-2 is-bold">{year.year}</div>
                    <div className="selection-year-bloc__payment">
                        {isLeaseAvailable ? (
                            <PaymentMethod
                                methodTitle={LocaleService.t('modelYearSection.lease')}
                                frequency={paymentFrequencyLabel}
                                calculatedPayment={calculatedLeasePayment}
                                term={selectedLeaseTerm}
                                cashdown={leaseCashDown}
                                displayCreditRate={this.props.displayCreditRate}
                            />
                        ) : (
                            <PaymentMethod methodTitle={LocaleService.t('modelYearSection.lease')} />
                        )}

                        {isFinanceAvailable ? (
                            <PaymentMethod
                                methodTitle={LocaleService.t('modelYearSection.finance')}
                                frequency={paymentFrequencyLabel}
                                calculatedPayment={calculatedFinancePayment}
                                term={selectedFinanceTerm}
                                cashdown={financeCashDown}
                                displayCreditRate={this.props.displayCreditRate}
                            />
                        ) : (
                            <PaymentMethod methodTitle={LocaleService.t('modelYearSection.finance')} />
                        )}

                        <PaymentMethod
                            methodTitle={LocaleService.t('modelYearSection.cashPurchase')}
                            retail={
                                purchaseMethods.cashPurchase.getRetail() -
                                purchaseMethods.cashPurchase.getTotalRebates()
                            }
                        />
                    </div>
                    <div className="selection-year-bloc__disclaimer">
                        <span>{taxesExcludedDisclaimer}</span>
                    </div>
                    <div className="selection-year-bloc__selectButton">
                        <div
                            className={buildButtonClass.join(' ')}
                            ref={(button) => {
                                this.buildButton = button;
                            }}
                        >
                            {LocaleService.t('modelYearSection.BUILD_IT')}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ModelYearComponent.defaultProps = {
    displayCreditRate: false,
    displayFactoryOrder: false,
    noMakeListStr: '',
    modelListStr: '',
};

ModelYearComponent.propTypes = {
    imageServer: PropTypes.shape({
        imageServerDomain: PropTypes.string.isRequired,
        imageServerFullSize: PropTypes.string.isRequired,
    }).isRequired,
    onYearClick: PropTypes.func.isRequired,
    paymentFrequencyLabel: PropTypes.string.isRequired,
    selectedModel: PropTypes.shape({
        make: PropTypes.string.isRequired,
        model: PropTypes.string.isRequired,
    }).isRequired,
    year: PropTypes.instanceOf(ModelYear.YearModel).isRequired,
    displayCreditRate: PropTypes.bool,
    displayFactoryOrder: PropTypes.bool,
    noMakeListStr: PropTypes.string,
    modelListStr: PropTypes.string,
};

ModelYearComponent.displayName = 'ModelYearComponent';

export default ModelYearComponent;
